import { TreatmentFlags } from './treatments'

export enum StandardSplitValue {
  ON = 'on',
  OFF = 'off',
  CONTROL = 'control',
}

export enum SupportPatientSearchQueryType {
  CONTROL = 'control',
  TSQUERY = 'tsquery',
  ORCLAUSE = 'or-clause',
  ORIGINAL = 'original',
}
export enum SearchByOrClauseInPatientsTab {
  ON = 'on',
  OFF = 'off',
  CONTROL = 'control',
}
export enum RescheduleButtonForSupportValue {
  HIDDEN = 'show',
  ON = 'hide',
  CONTROL = 'control',
}
export enum ShowB2BFlowToSupportUsers {
  HIDDEN = 'show',
  ON = 'hide',
  CONTROL = 'control',
}
export enum ShowB2BStatusToSupportUsers {
  HIDDEN = 'show',
  ON = 'hide',
  CONTROL = 'control',
}
export enum RescheduleButtonForClientValue {
  HIDDEN = 'show',
  ON = 'hide',
  CONTROL = 'control',
}
export enum ThrivewebBookingsValue {
  ENABLE = 'enable',
  DISABLE = 'disable',
  CONTROL = 'control',
}
export enum InsuranceModalRefreshValue {
  HIDDEN = 'hidden',
  ON = 'on',
  OFF = 'off',
}

export enum SelfBookingInsuranceVerificationValues {
  CHECK = 'check',
  SKIP = 'skip',
  CONTROL = 'control',
}
export enum DisplayToUsers {
  SHOW = 'show',
  HIDE = 'hide',
  CONTROL = 'control',
}
export enum SuggestionTreatmentValues {
  SUGGEST = 'suggest',
  SUPPRESS = 'suppress',
  CONTROL = 'control',
}
export enum SelfPayTreatmentValues {
  ALLOW = 'allow',
  DISABLE = 'disable',
}

export enum StimulantStateBucketValue {
  ONLINE_ALLOWED = 'A-online_stimulants_allowed',
  IN_PERSON_NOT_OFFERED = 'B-in_person_required_and_not_offered',
  IN_PERSON_OFFERED = 'C-in_person_required_and_offered',
  NOT_STIMULANT = 'D-nps_cannot_prescribe_controlled_substances',
  PSYCH_NOT_AVAILABLE = 'dummy_else_psych_not_available',
  CONTROL = 'control',
}

export type TreatmentValue<T> =
  // Map treatment names to their return type below by adding to ternary
  T extends TreatmentFlags.RESCHEDULE_BUTTON_FOR_SUPPORT
    ? RescheduleButtonForSupportValue
    : T extends TreatmentFlags.RESCHEDULE_BUTTON_FOR_CLIENT
    ? RescheduleButtonForClientValue
    : T extends TreatmentFlags.THRIVEWEB_BOOKINGS
    ? ThrivewebBookingsValue
    : T extends TreatmentFlags.SHOW_B2B_FLOW_TO_SUPPORT_USERS
    ? ShowB2BFlowToSupportUsers
    : T extends TreatmentFlags.SHOW_B2B_STATUS_TO_SUPPORT_USERS
    ? ShowB2BStatusToSupportUsers
    : T extends TreatmentFlags.SEARCH_BY_OR_CLAUSE_IN_PATIENTS_TAB
    ? SearchByOrClauseInPatientsTab
    : T extends TreatmentFlags.SUPPORT_PATIENT_SEARCH_QUERY_TYPE
    ? SupportPatientSearchQueryType
    : T extends TreatmentFlags.INSURANCE_MODAL_REFRESH
    ? InsuranceModalRefreshValue
    : T extends TreatmentFlags.SUPPORT_CAN_EDIT_PATIENT_INFO_IN_INSURANCE_SECTION
    ? StandardSplitValue
    : T extends TreatmentFlags.SELF_BOOKING_CAN_EDIT_PATIENT_INFO_IN_INSURANCE_SECTION
    ? StandardSplitValue
    : T extends TreatmentFlags.BACKGROUND_INSURANCE_VERIFICATION_SELF_BOOKING
    ? SelfBookingInsuranceVerificationValues
    : T extends TreatmentFlags.POC_SHOW_INSURANCE_VALIDATION_LOG
    ? StandardSplitValue
    : T extends TreatmentFlags.SUPPORT_CAN_SEE_INSURANCE_SUGGESTED_REVISIONS
    ? StandardSplitValue
    : T extends TreatmentFlags.SUPPORT_CAN_SEE_INSURANCE_SUGGESTED_VALUES
    ? StandardSplitValue
    : T extends TreatmentFlags.SELF_BOOKING_INSURANCE_STATUS
    ? DisplayToUsers
    : T extends TreatmentFlags.SELF_BOOKING_INSURANCE_SUGGESTIONS
    ? SuggestionTreatmentValues
    : T extends TreatmentFlags.SUPPORT_CAN_SEE_COINSURANCE_ON_INSURANCE_CARDS
    ? StandardSplitValue
    : T extends TreatmentFlags.SWITCH_TO_SELF_PAY_SELF_BOOKING_FOR_OVERRIDE_INSURANCES
    ? SelfPayTreatmentValues
    : T extends TreatmentFlags.SWITCH_TO_SELF_PAY_COE_FOR_OVERRIDE_INSURANCES
    ? SelfPayTreatmentValues
    : T extends TreatmentFlags.INSURANCE_ORDER_FLOW
    ? StandardSplitValue
    : T extends TreatmentFlags.INSURANCE_OVERRIDE_MESSAGE_COE
    ? StandardSplitValue
    : T extends TreatmentFlags.INSURANCE_OVERRIDE_MESSAGE_PATIENT
    ? StandardSplitValue
    : T extends TreatmentFlags.BLOCK_SP_FOR_PROVIDER_WITHOUT_INS
    ? StandardSplitValue
    : T extends TreatmentFlags.STIMULANT_STATE_BUCKET_MESSAGES
    ? StimulantStateBucketValue
    : never
